<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <h4 class="card-title" style="font-weight:bold;">Gestion des clients</h4>
            </template>

            <table class="table">
              <thead>
                <tr> 
                  <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">#</th>
                  <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">Roles</th>
                  <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">Noms et Prénoms</th>
                  <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">Contacts</th>
                  <th v-if="getRole == 5" scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">Actions</th>
                </tr>
              </thead>

              <tbody>
                
                <tr v-for="user in users" :key="user.id">
                  <td>{{ users.indexOf(user) + 1 }}</td>
                  <td> 
                    <select class="form-control" v-model="user.role" id="" disabled>
                        <option value="0">Client</option>
                        <option value="1">Livreur</option>
                        <option value="2">Commercial</option>
                        <option value="3">Superviseur</option>
                        <option value="4">Logisticien</option>
                        <option value="5">Administrateur</option>
                    </select>
                  </td>
                  <td>{{ user.name }}</td>
                  <td>{{ user.number }}</td>
                  <td v-if="getRole == 5">
                    <router-link :to="{path: '/Client_edit/' + user.id }" v-bind:tooltip="user.id"  class="btn btn-default">
                      <i class="fa fa-pencil" aria-hidden="true" style="color:blue; font-weight:bold"></i>
                    </router-link>
                    <button @click="removeUsers(user.id)" class="btn btn-default">
                      <i class="fa fa-trash" aria-hidden="true" style="color:red; font-weight:bold"></i>
                    </button>
                  </td>
                </tr>

              </tbody>
            </table>

          </card>

          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              first-number
            ></b-pagination>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import "firebase/auth";
  import { db } from '../../main';
  import Swal from "sweetalert2";
  
  export default {
    name: "Clients",
    data() {
      return {
        users: [],
        rows: 100,
          perPage: 3,
          currentPage: 3,
        getRole :0,
        role:"",
      };
    },
    
    methods: {
      removeUsers(key){
        Swal.fire({
        title: 'Êtes vous sûr?',
        text: "Voulez vous vraiment supprimer ce compte!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#34B76E',
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Supprimer'
      }).then((result) => {
        if (result.isConfirmed) {
          db.ref("users").child(key).remove();
          Swal.fire(
            'Supprimé!',
            'Le compte a été supprimé avec succès.',
            'success'
          )
        }
      })
      }
    },
    
    created() {
      db.ref("users")
        .orderByChild("name")
        .on('value', dataSnapshot => {
          const itemsArray = [];
          dataSnapshot.forEach(childSnapshot => {
            const childData = childSnapshot.val();
            itemsArray.push({
              id: childData.id,
              role: childData.role,
              name: childData.name,
              number: childData.number,
              email: childData.email,
            });
          });
          this.users = itemsArray;
        });

      this.getRole =  this.$store.getters.user.data.role;
      if(this.getRole == 0){
        this.role = 'client'
      } else if(this.getRole == 1){
        this.role = 'livreur'
      } else if(this.getRole == 2){
        this.role = 'commercial'
      } else if(this.getRole == 3){
        this.role = 'superviseur'
      } else if(this.getRole == 4){
        this.role = 'logisticien'
      } else if(this.getRole == 5){
        this.role = 'administrateur'
      }else{
        return this.role = 'Erreur Système'
      }
    },

  };

  

</script>

<style>
    .btn-primary {
        margin-right: 12px;
    }
</style>

